<template>

    <div>
        <div class="grid grid-cols-6 gap-6" v-if="loaded">

            <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': value.fieldHasErrors('address_street') }">
                <label for="address_street" class="block text-sm font-medium text-gray-700">Street Address<i></i></label>
                <input type="text" name="address_street" id="address_street" v-model="value.data.address_street">
                <span v-if="value.fieldHasErrors('address_street')">{{ value.getFieldError('address_street') }}</span>
            </div>

            <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': value.fieldHasErrors('address_2') }">
                <label for="address_2" class="block text-sm font-medium text-gray-700 -mt-4">&nbsp;</label>
                <input type="text" name="address_2" id="address_2" v-model="value.data.address_2">
                <span v-if="value.fieldHasErrors('address_2')">{{ value.getFieldError('address_2') }}</span>
            </div>

            <div class="form-control hidden xl:flex md:col-span-2">&nbsp;</div>

            <div class="form-control col-span-6 md:col-span-6 xl:col-span-2" :class="{ 'form-control-error': value.fieldHasErrors('town_city') }">
                <label for="town_city" class="block text-sm font-medium text-gray-700">Town/City<i></i></label>
                <input type="text" name="town_city" id="town_city" v-model="value.data.town_city">
                <span v-if="value.fieldHasErrors('town_city')">{{ value.getFieldError('town_city') }}</span>
            </div>

            <div class="form-control col-span-6 md:col-span-6 xl:col-span-2" :class="{ 'form-control-error': value.fieldHasErrors('county') }">
                <label for="county" class="block text-sm font-medium text-gray-700">County</label>
                <input type="text" name="county" id="county" v-model="value.data.county">
                <span v-if="value.fieldHasErrors('county')">{{ value.getFieldError('county') }}</span>
            </div>

            <div class="form-control hidden xl:flex md:col-span-2">&nbsp;</div>

            <div class="form-control col-span-6 md:col-span-6 xl:col-span-2" :class="{ 'form-control-error': value.fieldHasErrors('country') }">
                <label for="country" class="block text-sm font-medium text-gray-700">Country</label>
                <input type="text" name="country" id="country" v-model="value.data.country">
                <span v-if="value.fieldHasErrors('country')">{{ value.getFieldError('country') }}</span>
            </div>

            <div class="form-control col-span-6 md:col-span-6 xl:col-span-2" :class="{ 'form-control-error': value.fieldHasErrors('postcode') }">
                <label for="postcode" class="block text-sm font-medium text-gray-700">Postcode<i></i></label>
                <input type="text" name="postcode" id="postcode" v-model="value.data.postcode">
                <span v-if="value.fieldHasErrors('postcode')">{{ value.getFieldError('postcode') }}</span>
            </div>

            <div class="form-control col-span-6 sm:col-span-4">
                <button type="button" class="btn text-sm" @click.prevent="showAddressLookup">Lookup Address</button>
            </div>


            <transition
                enter-active-class="ease-out duration-300"
                enter-from-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="ease-in duration-200"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <div class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true" v-show="display">
                    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" @click="closeLookup"></div>

                        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                            <div>
                                <div>
                                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                        Lookup Address
                                    </h3>

                                    <div class="my-4 flex border-l-4 border-error-500 bg-error-50 text-gray-700 px-2 py-2 rounded tracking-wide shadow items-center text-error-400" v-if="get_address.hasError()">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                        <p class="text-error-700 text-sm">
                                            {{ get_address.getErrorMessage() }}
                                        </p>
                                    </div>

                                    <div class="mt-2">
                                        <div class="grid grid-cols-6 gap-6 mb-4">
                                            <div class="form-control col-span-3">
                                                <label for="lookup_address_1" class="block text-sm font-medium text-gray-700">Street Address</label>
                                                <input type="text" name="lookup_address_1" id="lookup_address_1" v-model="value.data.address_street">
                                            </div>

                                            <div class="form-control col-span-3" :class="{ 'form-control-error': get_address.fieldHasErrors('postcode') }">
                                                <label for="lookup_postcode" class="block text-sm font-medium text-gray-700">Postcode<i></i></label>
                                                <input type="text" name="lookup_postcode" id="lookup_postcode" v-model="value.data.postcode">
                                                <span v-if="get_address.fieldHasErrors('postcode')">{{ get_address.getFieldError('postcode') }}</span>
                                            </div>
                                        </div>

                                        <div v-if="get_address.searching || get_address.results">
                                            <Loading :message="false" :show_long_loading="false" v-if="get_address.searching"></Loading>
                                            <div class="h-56 overflow-scroll p-2" v-if="get_address.results">

                                                <table class="min-w-full divide-y divide-gray-200">
                                                    <thead class="bg-gray-50">
                                                    <tr>
                                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Address
                                                        </th>
                                                        <th scope="col" class="relative px-6 py-3">
                                                            <span class="sr-only">Select</span>
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody class="text-gray-600">
                                                        <tr class="colored-row" v-for="(address, index) in get_address.results.addresses">
                                                            <td class="px-6 py-4 whitespace-nowrap text-xs font-medium">
                                                                {{ address[0] }}<br>
                                                                <span class="text-gray-400">{{ address[3]}}, {{ address[4] }},</span> {{ value.data.postcode }}
                                                            </td>
                                                            <td class="text-right">
                                                                <button type="button" class="btn-outline text-xs" @click.prevent="selectAddress(index)">Select Address</button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="mt-5 mt-6 grid grid-cols-2 gap-3 grid-flow-row-dense">
                                <button type="button" class="btn-outline justify-center" @click.prevent="closeLookup">
                                    Close
                                </button>
                                <button type="button" class="btn justify-center" @click.prevent="lookupAddress">
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <Loading :message="false" :show_long_loading="false" v-else></Loading>
    </div>

</template>

<script>

import Loading from "./Loading";
import {GetAddress} from "../../app/Support/GetAddress";

export default {
    name: "Address",
    props: ['value'],
    data() {
        return {
            get_address: null,
            display: false,
            loaded: false,
        }
    },
    components: {
        Loading
    },
    methods: {
        showAddressLookup() {
            let vm = this;

            if (vm.value.data.postcode) {
                vm.lookupAddress();
            }

            vm.display = true;
        },
        lookupAddress() {
            let vm = this;

            vm.get_address.find(vm.value.data.postcode, vm.value.data.address_street);
        },
        selectAddress(index) {
            let vm = this;

            vm.get_address.selectAddress(index, vm.value.data.postcode).then(result => {
                vm.value.data.address_street = result.address_street;
                vm.value.data.address_2 = result.address_2;
                vm.value.data.town_city = result.town_city;
                vm.value.data.county = result.county;
                vm.value.data.country = result.country;
                vm.value.data.postcode = result.postcode;

                vm.closeLookup();
            });
        },
        closeLookup() {
            this.get_address.resetSearch();
            this.display = false;
        }
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.get_address = new GetAddress(process.env.MIX_GET_ADDRESS_KEY);

            resolve(true);
        }).then(result => {
            vm.loaded = result;
        });
    }
}
</script>


